import { combineReducers } from 'redux';
import actsReducer from './actsReducer';
import audienceCategoriesReducer from './audienceCategoriesReducer';
import audienceMotivesReducer from './audienceMotivesReducer';
import audiencesReducer from './audiencesReducer';
import audienceTypesReducer from './audienceTypesReducer';
import authReducer from './authReducer';
import charactersReducer from './charactersReducer';
import defensoriesReducer from './defensoriesReducer';
import dependenciesReducer from './dependenciesReducer';
import dependencyTypesReducer from './dependencyTypesReducer';
import functionariesReducer from './functionariesReducer';
import functionaryTypesReducer from './functionaryTypesReducer';
import inhibitionsReducer from './inhibitionsReducer';
import inhibitionTypesReducer from './inhibitionTypesReducer';
import intermediatesReducer from './intermediatesReducer';
import judgesReducer from './judgesReducer';
import levelsReducer from './levelsReducer';
import licencesReducer from './licencesReducer';
import licenceTypesReducer from './licenceTypesReducer';
import notificationsReducer from './notificationsReducer';
import notificationTypesReducer from './notificationTypesReducer';
import objectsReducer from './objectsReducer';
import ofijusReducer from './ofijusReducer';
import personTypesReducer from './personTypesReducer';
import recusesReducer from './recusesReducer';
import resultModalitiesReducer from './resultModalitiesReducer';
import resultTypesReducer from './resultTypesReducer';
import roomsReducer from './roomsReducer';
import serversReducer from './serversReducer';
import systemReducer from './systemReducer';
import turnsReducer from './turnsReducer';
import unitsReducer from './unitsReducer';
import usersReducer from './usersReducer'; 


export default combineReducers({
    acts: actsReducer,
    audienceCategories: audienceCategoriesReducer,
    audienceMotives: audienceMotivesReducer,
    audiences: audiencesReducer,
    audienceTypes: audienceTypesReducer,
    auth: authReducer,
    characters: charactersReducer,
    defensories: defensoriesReducer,
    dependencies: dependenciesReducer,
    dependencyTypes: dependencyTypesReducer,
    functionaries: functionariesReducer,
    functionaryTypes: functionaryTypesReducer,
    inhibitions: inhibitionsReducer,
    inhibitionTypes: inhibitionTypesReducer,
    intermediates: intermediatesReducer,
    judges: judgesReducer,
    levels: levelsReducer,
    licences: licencesReducer,
    licenceTypes: licenceTypesReducer,
    notifications: notificationsReducer,
    notificationTypes: notificationTypesReducer,
    objects: objectsReducer,
    ofijus: ofijusReducer,
    personTypes: personTypesReducer,
    recuses: recusesReducer,
    resultModalities: resultModalitiesReducer,
    resultTypes: resultTypesReducer,
    rooms: roomsReducer,
    servers: serversReducer,
    system: systemReducer,
    turns: turnsReducer,
    units: unitsReducer,
    users: usersReducer
});